import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../shared/environments/environment';
import { Observable, share } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { IItem, IItemCreate, IItemUpdate } from '../typing/item.interface';

@Injectable({
    providedIn: 'root'
})
export class ItemService {

    constructor(private http: HttpClient) {
    }

    getItems(query: Params): Observable<IPaginatedResponse<IItem>> {
        return this.http.get<IPaginatedResponse<IItem>>(`${environment.API_BASE_PATH}/items`, {params: query});
    }

    getItemsTest(): Observable<IPaginatedResponse<IItem>> {
        return this.http.get<IPaginatedResponse<IItem>>(`${environment.API_BASE_PATH}/items`);
    }

    getItem(id: number): Observable<IItem> {
        return this.http.get<IItem>(`${environment.API_BASE_PATH}/item/${id}`).pipe(share());
    }

    createItem(item: IItemCreate): Observable<IItem> {
        return this.http.post<IItem>(`${environment.API_BASE_PATH}/item`, item);
    }

    updateItem(item: IItemUpdate): Observable<IItem> {
        return this.http.put<IItem>(`${environment.API_BASE_PATH}/item/${item.id}`, item);
    }

    deleteItems(data: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/items`, {
            body: data
        });
    }
}
